import React, { useEffect } from "react";
import styled from "styled-components";
import ReactTooltip from "react-tooltip";

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

const Icon = styled.div`
  height: 30px;
  width: 30px;
  border-radius: 50%;
  background-color: ${(p) => p.color};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 4px;
  cursor: pointer;
`;

const Assigned = ({ row, name }) => {
  useEffect(() => {
    ReactTooltip.rebuild();
  }, []);

  const { assign = [] } = row;

  //const { applicant = [] , mandate = [] , coApplicant = [], owner = [], reviewer = [] } = assign || {}

  return (
    <Wrapper>
      {assign &&
        Array.isArray(assign) &&
        assign.map((circle, i) => {
          return (
            <Icon
              key={`${row._id}-${i}`}
              color={circle.type === "group" ? "#C765A3" : "#F765A3"}
              data-tip={`${circle.name}`}
              data-place="top"
              data-delay-show="0"
              className={`app${i}`}
            >
              {circle.short}
            </Icon>
          );
        })}
    </Wrapper>
  );
};

export default Assigned;
